import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { Task, TasksRequest, TasksResponse } from './types'
import { isAllElementsOfSearchTextNotExist } from '../../../../libs/utils'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'client.clientId') {
        return [`client.id`, item[1]?.toLowerCase()]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

export const tasksListMounted = createEvent<TasksRequest>()

export const getTasks = fx<TasksRequest, TasksResponse>({
  method: 'GET',
  url: `/promo/golden_may/participant_task`,
})

export const $tasks = restore<Task[]>(
  getTasks.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfTasks = restore(
  getTasks.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: tasksListMounted,
  fn: ({ limit, page, orderBy, orderDirection, filters, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'taskType'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getTasks,
})
